import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { IonicModule } from "@ionic/angular";
import { QuestionsModule } from "../../questions/questions.module";
import { ApgBeatYourBrokerHeaderComponent } from "./apg-beat-your-broker-header.component";

@NgModule({
  imports: [ 
    CommonModule,
    IonicModule,
    QuestionsModule
   ],
  providers: [
  ],
  exports: [
    ApgBeatYourBrokerHeaderComponent
  ],
  declarations: [
    ApgBeatYourBrokerHeaderComponent
  ]
})
export class ApgBeatYourBrokerHeaderModule { }

